module.exports = __webpack_public_path__ + "static/media/logsba.e465eba4.png";